import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// Gate for routes that require a logged-in user. Unauthenticated visitors are
// sent to the Create Account page with the intended destination preserved in a
// `redirect` query param, so they return there after authenticating. The signup
// screen links to sign-in for agents who already have an account.
const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <h3>Loading...</h3>;
  }

  if (!user) {
    const dest = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signup?redirect=${dest}`} replace />;
  }

  return children;
};

export default RequireAuth;
